import { fetchMealHistory } from "./fetchMealHistory";

export const actions = {
    fetchMealHistory,
};
